import { render, staticRenderFns } from "./DocumentMarginComponent.vue?vue&type=template&id=1a966e5a&scoped=true&"
import script from "./DocumentMarginComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentMarginComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMarginComponent.vue?vue&type=style&index=0&id=1a966e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a966e5a",
  null
  
)

export default component.exports